import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';
import { cm } from 'src/utils/classNames';
import Tooltip from 'src/components/primitives/Tooltip/Tooltip';
import { signDependentValue } from 'src/utils/signDependentValue';

interface PnlBreakdownTooltipProps extends WithChildren, WithClassName {
	pnl: number;
	pnlNotional: string;
	positionPnlNotional: string;
	feesAndFundingNotional: string;
}

export function PnlBreakdownTooltip({
	pnl,
	pnlNotional,
	positionPnlNotional,
	feesAndFundingNotional,
	children,
	className,
}: PnlBreakdownTooltipProps) {
	return (
		<Tooltip
			decoration="none"
			content={
				<div
					className={cm(
						'flex w-[244px] flex-col items-start gap-y-md',
						className
					)}
				>
					<div className="flex w-full justify-between typo-label-sm">
						<span className="text-text-default">Final P&L</span>
						<span
							className={signDependentValue(pnl, {
								positive: 'text-text-positive-green-button',
								negative: 'text-text-negative-red-button',
								zero: 'text-text-default',
							})}
						>
							{pnlNotional}
						</span>
					</div>

					<div className="flex w-full flex-col gap-y-xs typo-body-xs text-text-default">
						<div className="flex justify-between">
							<span>Position P&L</span>
							<span>{positionPnlNotional}</span>
						</div>
						<div className="flex justify-between">
							<span>Fees</span>
							<span>{feesAndFundingNotional}</span>
						</div>
					</div>
				</div>
			}
		>
			{children}
		</Tooltip>
	);
}
